import React from "react"

export default function Header(props) {
    return <h1 className="h1">{props.headerText}</h1>
}